import { useTranslation } from 'react-i18next'

import { FileIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Link, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EmailAttachments = ({ attachments }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Styles.Container isList={attachments.length > 1}>
      <Text tag="span" type="bodyMBold">
        {t('Adjuntos')}:
      </Text>
      <Styles.List>
        {attachments.map((attachment, index) => (
          <Styles.Attachment key={`${attachment.url}-${index}`}>
            <FileIcon size={16} color={theme.colors.text.muted} />
            <Link href={attachment.url} target="_blank" rel="noopener noreferrer">
              <Text tag="span" type="linkS">
                {attachment.name}
              </Text>
            </Link>
          </Styles.Attachment>
        ))}
      </Styles.List>
    </Styles.Container>
  )
}

export default EmailAttachments
